/* eslint-disable no-useless-rename */
import { Dispatch, SetStateAction, useEffect } from 'react';
import { InputLabel } from '../../../styles/FontStyles';
import { Button } from '../../../styles/GlobalComponents';
import { FlexCenter } from '../../../styles/stylesStyled';
import {
  ImagePHContainer,
  ImagePHContainerFilled,
  KycBrowseFilesButton,
  Medium,
  Small
} from '../KycStyled';

import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { useWindowWide } from '../../../helpers/wideScreen';
import { Dropzone } from './Dropzone';
import { ImgState } from './KycDocumentPhotos';

interface RenderPassportType {
  id: number;
  percentage: number;
  setModal3: Dispatch<SetStateAction<boolean>>;
  setImage3: Dispatch<SetStateAction<string>>;
  uploadPassportHandler: any;
  setImgStatePassport: Dispatch<SetStateAction<number>>;
  imgStatePassport: number;
  passport: string;
  setPassport: Dispatch<SetStateAction<string>>;
  setDocumentPassport: Dispatch<SetStateAction<File | string>>;
}

export const RenderPassport = ({
  id,
  percentage,
  setModal3,
  setImage3,
  uploadPassportHandler,
  setImgStatePassport,
  imgStatePassport,
  passport,
  setPassport,
  setDocumentPassport
}: RenderPassportType) => {
  const { t } = useTranslation('kyc');
  const wide = useWindowWide(1000);

  const {
    acceptedFiles: acceptedFiles,
    getRootProps: getRootProps,
    isDragAccept: isDragAccept,
    isDragReject: isDragReject
  } = useDropzone({
    accept: { 'image/*': [] },
    multiple: false,
    useFsAccessApi: false
  });

  useEffect(() => {
    const file = acceptedFiles[0];

    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setPassport(objectUrl);
      setDocumentPassport(file);
      setImgStatePassport(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptedFiles]);

  return (
    <>
      {id === 3 && (
        <div>
          <InputLabel>Passport</InputLabel>
          {passport ? (
            <ImagePHContainerFilled style={{ width: wide ? 375 : '' }}>
              <img
                src={passport}
                alt='upload'
                style={{
                  height: '182px',
                  objectFit: 'cover',
                  filter: imgStatePassport === 2 ? 'blur(8px)' : 'blur(0px)',
                  transition: '.3s filter ease'
                }}
              />
              <ImgState
                state={imgStatePassport}
                setImgState={setImgStatePassport}
                percentage={percentage}
                uploadHandler={(e: any) => uploadPassportHandler(e)}
                retake={() => {
                  setImage3('');
                  setModal3(true);
                }}
              />
            </ImagePHContainerFilled>
          ) : (
            <Dropzone
              // acceptedFiles={acceptedFiles}
              getRootProps={getRootProps}
              isDragAccept={isDragAccept}
              isDragReject={isDragReject}>
              <ImagePHContainer style={{ width: wide ? 375 : '' }}>
                <div
                  style={{
                    textAlign: 'center'
                  }}>
                  <Medium>{t('document_photos.photo_card_title')}</Medium>
                  <Small>{t('document_photos.photo_card_subtitle')}</Small>

                  <FlexCenter style={{ justifyContent: 'center' }}>
                    <Button
                      fs='12px'
                      h='34px'
                      maxWidth='111px'
                      mr='12'
                      type='button'
                      onClick={() => setModal3(true)}>
                      {t('document_photos.take_photo_button')}
                    </Button>
                    <KycBrowseFilesButton>
                      <input
                        type='file'
                        accept='image/*'
                        style={{ display: 'none' }}
                        onChange={(e) => uploadPassportHandler(e)}
                      />
                      {t('document_photos.browse_files_button')}
                    </KycBrowseFilesButton>
                  </FlexCenter>
                </div>
              </ImagePHContainer>
            </Dropzone>
          )}
        </div>
      )}
    </>
  );
};
